export default __webpack_public_path__ + "static/media/bannerCrisBarros.073ebe74.svg";